import { render, staticRenderFns } from "./ResolutionCardDetails.vue?vue&type=template&id=55203c6c&"
import script from "./ResolutionCardDetails.vue?vue&type=script&lang=js&"
export * from "./ResolutionCardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports